import LogisticRoutes from "./logistic";

export const Routes = [...LogisticRoutes];

export default Routes;
